import { useEffect, useRef } from 'react'
import useCoupon from '~/src/hooks/cart/useCoupon'
import { useEoValue } from '~/src/hooks/useEoState'
import { CART_OF_FIRM_SELECTOR } from '~/src/stores/cart'
import { CHECKOUT_FORM_STATE, CheckoutFormState } from '~/src/stores/checkout'
import { PRICE_LIST_STATE } from '~/src/stores/product/price-list'
import { CartProduct } from '~/src/types/CartProduct'

const useCheckCouponEffect = () => {
  const { checkCouponValidity } = useCoupon()
  const cart: CartProduct[] = useEoValue(CART_OF_FIRM_SELECTOR)
  const checkoutFormState: CheckoutFormState = useEoValue(CHECKOUT_FORM_STATE)
  const priceList = useEoValue(PRICE_LIST_STATE)

  const previousCartLength = useRef<number | null>(null)
  const previousPriceListId = useRef<number | null>(null)

  useEffect(() => {
    if (!checkoutFormState.coupon || cart.length === 0) {
      return
    }

    const priceListId = priceList.length > 0 ? priceList[0].price_list_id : 0
    const cartLength = cart.reduce((quantity, product) => quantity + product.quantity, 0)

    if (previousCartLength.current === null
        || previousCartLength.current !== cartLength
        || previousPriceListId.current !== priceListId) {
      checkCouponValidity(checkoutFormState.coupon.code!)
    }

    previousCartLength.current = cartLength
    previousPriceListId.current = priceListId
  }, [ cart, checkoutFormState.coupon, checkCouponValidity, priceList ])
}

export default useCheckCouponEffect
